import React from "react";
import Configurer from "../../components/Configurer";
import TLink from "../../components/TLink";
import { checkTranslation, translate } from "../../utils/useful";


class Dashboard extends React.Component {

    state = {
    }

    render() {
        return (

            <Configurer
                // settingsInfo={{ headerTitle: "Dashboard" }}
                settingsInfo={{ headerTitle: translate("Dashboard"), button: { goBack: false } }}

                title={translate("Dashboard")}
                description={"This is the dashboard"}
                className="px-0 px-md-3"
            >

                <div className="px-0 px-md-3 mt-0 mt-md-4" style={{}}>



                    <div className="d-flex w-100" style={{ justifyContent: "space-between" }}>
                        <div className="px-2 mt-0 w-100">

                            <p className="text-ultra-big fs-md-18 font-bold m-0 p-0" style={{ lineHeight: 1.2 }}>{translate('User Profile')}</p>
                            <div className="flexc">
                                <p className="text-normal text-bold  m-0 p-0" style={{ color: '#9ab' }}>{this.props.user?.info?.fullname}</p>

                                <button onClick={() => this.props.logoutAlert()} className="text-center py-1 px-4 mx-1 mt-3 d-md-none" style={{ borderBottom: '0px solid #F87C56', backgroundColor: '#F87C5630', borderRadius: '6px' }}>
                                    <p className="text-bold text-smaller py-1" style={{ color: '#F87C56' }}>Logout</p>
                                </button>
                            </div>
                        </div>

                        <button onClick={() => this.props.openMobileMenu()} className=" d-md-none " style={{ flex: 1, boxShadow: '0px 0px 15px #00000005', color: '#789' }}>
                            <img className=" " src="/images/menu.png" alt="" width="30px" />
                        </button>

                    </div>



                    <div className="w-100 py-4 px-4 mb-4 mt-md-4 mt-2 flexcb" style={{ backgroundImage: 'linear-gradient(90deg, rgb(224 237 255 / 51%), rgb(246 246 246))', borderRadius: 8 }}>
                        <div>
                            <p className="font-bold text-big">{translate("Secure your account")}</p>
                            <p className="text-small mt-2">{translate("dashbaord-secure-desc")}</p>
                            <p className="text-small mt-2">{translate('Regards')},</p>
                            {/* <p className="text-small mt-2">Narvan Devops team</p> */}


                        </div>
                        <div className="d-none d-md-block">
                            <img className="w-100" style={{ objectFit: "cover" }} src="/images/icons3/testt-removebg-preview.png" alt="" />
                        </div>
                    </div>


                    <div className="row mx-0 mt-0 mt-md-4 p-0">



                        {this.props.pages.map((prop, index) => {
                            let link = [...this.props.baseUrl]
                            if (prop.key && prop.key != '') {
                                link.push(prop.key)
                            }
                            // console.log(link)
                            if (!prop.dontShowInDashboard) {
                                return (
                                    <div className="col-6 col-lg-3 p-0" key={index}>
                                        <div className="text-center p-3 button-light-hover border-radius-8 w-100">
                                            <TLink className={'w-100'}  to={link.join('/')}>

                                                {/* <button onClick={() => this.props.changePage(prop.key)} className="text-center p-3 button-light-hover border-radius-8 w-100"> */}
                                                <img src={prop.icon} width="25px" alt="" />
                                                <p className="font-bold mt-2 text-normal">{checkTranslation(prop.name)}</p>
                                                {/* <p className="text-smaller" style={{ color: '#9ab' }}>This is the description of this desction</p> */}

                                                {/* </button> */}
                                            </TLink>
                                        </div>
                                    </div>
                                )
                            }
                        })}

                    </div>
                </div>

            </Configurer>
        )
    }


}


export default Dashboard
